import { Fragment, useContext, useMemo } from 'react';
import Button from '../../../../components/Button';
import InfoPopUp from '../../../../components/InfoPopUp';
import modalContext from '../../../../context/modal/modalContext';
import { formatUSD } from '../../../../helpers/formats';
import useIncentivizedEarnings from '../../../../hooks/web3/vault/useIncentivizedEarnings';

const ClaimableSpoolsIncentivizedRewards = () => {
    const { openModal } = useContext(modalContext);

    const { incentivizedEarnings } = useIncentivizedEarnings();

    const claim = () => {
        openModal('claimAllSpoolsIncentivizedRewards');
    };

    const totalClaimable = useMemo(
        () =>
            incentivizedEarnings?.reduce((total, { claimableAmount, usdValue }) => {
                return (total += +claimableAmount * +usdValue);
            }, 0),
        [incentivizedEarnings]
    );

    return (
        <div className='claimable-earnings'>
            <div className='amount-container'>
                <p>Total Value of Your Currently Claimable Incentivized Rewards</p>
                <div className='amount'>
                    <span>~${formatUSD(totalClaimable || 0)}</span>
                    <InfoPopUp>
                        <span className='block'>Total Claimable Earnings:</span>
                        {incentivizedEarnings?.length ? (
                            incentivizedEarnings
                                .filter(({ isRemoved }) => !isRemoved)
                                .map(({ claimableAmount, token, usdValue }, index) => (
                                    <Fragment key={index}>
                                        <strong
                                            className={`block ${index !== 0 ? 'mt' : ''}`}
                                        >
                                            {formatUSD(claimableAmount || 0)}{' '}
                                            {token.symbol}
                                        </strong>
                                        <span className='block'>
                                            {`(~$${formatUSD(
                                                +claimableAmount * +usdValue || 0
                                            )})`}
                                        </span>
                                    </Fragment>
                                ))
                        ) : (
                            <strong className='block'>N/A</strong>
                        )}
                    </InfoPopUp>
                </div>
            </div>
            <Button onClick={claim} disabled={!totalClaimable}>
                Claim All Incentivized Rewards
            </Button>
        </div>
    );
};

export default ClaimableSpoolsIncentivizedRewards;
